export default function groupEntities(entities, size) {
  const entitiesSet = [...entities];
  const controledSize = size ? Number(size) : entitiesSet.length;
  const chunks = [];

  while (entitiesSet.length) {
    chunks.push(entitiesSet.splice(0, controledSize));
  }

  return chunks;
}
